import { openReactActionDialog} from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth} from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages} from '~src/codegen/Localize';
import { EditableConnection} from '~src/connectivity/components/EditConnection/IEditConnectionDialog';
import { ReadOnlyEditableConnection } from '~src/connectivity/components/EditConnection/utils/EditConnectionActionTypes';
import { EditConnectionReactActionUtils } from '~src/connectivity/components/EditConnection/utils/EditConnectionActionUtils';
import { EditFilebasedConnectionActionDialogBody } from '~src/connectivity/components/EditFilebasedConnection/components/EditFilebasedConnectionActionDialogBody';
import { updateUseRemoteQueryAgent } from '~src/connectivity/components/EditFilebasedConnection/utils/EditFilebasedConnectionActionUtils';
import { IDataConnectionInfo } from '~src/datasource/dataConnection/models/IDataConnectionInfo';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export interface EditFilebasedConnectionDialogProps {
  prompt: string;
  showNetworkType: boolean;
}

export interface EditFilebasedConnectionDialogState {
  usingRemoteQueryAgent: boolean | undefined;
}

export namespace EditFilebasedConnectionAction {
  export async function confirmEditFilebasedConnections(
    connections: EditableConnection[]
  ): Promise<Promise<any>> {
    const {editConnectionDialogProps, editConnectionDialogState} = await createDialogStateAndProps(connections);

    const modalInstance = openReactActionDialog<EditFilebasedConnectionDialogProps, EditFilebasedConnectionDialogState, IResult>({
      title: Messages.editConnection(),
      bodyComponent: EditFilebasedConnectionActionDialogBody,
      initialBodyProps: editConnectionDialogProps,
      initialDialogState: editConnectionDialogState,
      actionName: Messages.save(),
      action: (_props, dialogState) => updateUseRemoteQueryAgent(connections, dialogState),
      dialogWidth: TabDialogWidth.width375px,
      dismissDialogOnActionFailed: true,
      actionDisabled: () => false
    });

    return modalInstance.result;
  }
}

async function createDialogStateAndProps(
  connections: EditableConnection[]
) {
  const firstConnection: ReadOnlyEditableConnection | undefined = connections[ 0 ];
  const datasource: IDataSourceInfo = ((firstConnection as IDataConnectionInfo).datasource) as IDataSourceInfo;

  const editConnectionDialogProps: EditFilebasedConnectionDialogProps = {
    prompt: EditConnectionReactActionUtils.makePrompt(connections.length),
    showNetworkType: getSessionManagementServiceInstance().isOnlineEnvironment() &&
      EditConnectionReactActionUtils.showNetworkType(datasource),
  };
  const editConnectionDialogState: EditFilebasedConnectionDialogState = {
    usingRemoteQueryAgent: connections.length >= 1 && firstConnection.usingRemoteQueryAgent
  };
  return { editConnectionDialogProps, editConnectionDialogState };
}